<template>
  <div class="container">
    <div class="header">
      <div class="title">教师课表</div>
    </div>
    <div class="c-body">
      <div class="cell-box" @click="showPopupClick(1)">
        <div class="cell-left">校区</div>
        <div class="cell-right">
          <p>{{ schooleVal === '' ? '请选择校区' : schooleVal.text }}</p>
          <van-icon name="arrow" color="#ddd" size="18" />
        </div>
      </div>
      <div class="cell-box" @click="showPopupClick(2)">
        <div class="cell-left">学年学期</div>
        <div class="cell-right">
          <p>{{ yearVal === '' ? '请选择学年学期' : yearVal.text }}</p>
          <van-icon name="arrow" color="#ddd" size="18" />
        </div>
      </div>
      <div class="query-btn" @click="queryClick">查询</div>
    </div>
    <!-- 弹出层 -->
    <van-popup v-model="showPopup" position="bottom" round :style="{ height: '31%' }">
      <van-picker :default-index="defaultIndex" :show-toolbar="true" :columns="columns" @confirm="popupOk" @cancel="closeDU" />
    </van-popup>
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      defaultIndex:0,
      teacherList: [],
      schooleVal: '',
      schooleColums: [],
      yearVal: {
        text: '',
        value: ''
      },
      yearColums: [],

      classColums: [],
      showPopup: false,
      curPopup: -1, //1 校区 2 年级 3 班级
      columns: [],
      AcademicSessionID: '', //学期信息
      TeacherID: '' //教师列表需要防止重复id
    }
  },
  created() {
    this.getSessionNodeList()
  },
  mounted() {},
  methods: {
    showPopupClick(val) {
      if (val === 1) {
        this.columns = this.schooleColums
        this.curPopup = 1
      } else if (val === 2) {
        this.columns = this.yearColums
        this.curPopup = 2
      }
      this.showPopup = true
    },
    closeDU() {
      this.showPopup = false
    },
    popupOk(selectedValues, selectedOptions, selectedIndexes) {
      if (this.curPopup === 1) {
        this.schooleVal = selectedValues
        // 获取教师 再次调
        this.getTeacher()
      } else if (this.curPopup === 2) {
        let idArr = [
          this.yearColums[selectedOptions[0]].value,
          this.yearColums[selectedOptions[0]].children.length > 0
            ? this.yearColums[selectedOptions[0]].children[selectedOptions[1]].value
            : 0
        ]
        let text = selectedValues[0]
        if (selectedValues[1] !== undefined) {
          text = text + selectedValues[1]
        }
        this.yearVal = {
          text: text,
          value: idArr.join(',')
        }
        this.AcademicSessionID = Number(this.yearVal.value.split(',')[1])
        this.getTeacher()
      }
      this.showPopup = false
    },
    queryClick() {
      if (this.teacherList.length === 0) {
        this.$toast.fail('暂无教师数据')
        return false
      }
      if (this.schooleVal === '') {
        this.$toast.fail('请先选择校区')
        return false
      }
      if (this.yearVal === '') {
        this.$toast.fail('请先选择学年学期')
        return false
      }
      this.$router.push({
        path: 'teacherSchedule',
        query: {
          schooleVal: JSON.stringify(this.schooleVal),
          AcademicSessionID: this.AcademicSessionID,
          teacherData: JSON.stringify(this.teacherList[0].list[0]),
          teacherID: this.TeacherID
        }
      })
    },
    //获取教师
    async getTeacher() {
      this.xy.loading()
      let res = await this.xyapi.post(
        this.$store.state.apiPath +
          '/api/ReportPermissionTimeTable/GetMobilePermissionTimeTableTeacherIncludeList',
        {
          ApplicationID: this.$store.state.common.menuIDs[1],
          AcademicSessionID: this.AcademicSessionID,
          SchoolDistrictID: this.schooleVal.value
        }
      )
      this.xy.unloading()
      if (res.success) {
        this.teacherList = res.data
        if (this.teacherList.length) {
          this.TeacherID =
            this.teacherList[0].list[0].TeacherID + ',' + this.teacherList[0].DisciplineID
        }
      } else {
        this.$toast.fail(res.data)
      }
    },
    // 获取校区
    async getSchoole(data) {
      this.xy.loading()
      let res = await this.xyapi.post(
        this.$store.state.apiPath +
          '/api/ReportPermissionTimeTable/GetMobilePermissionTimeTableTeacherSchoolDistictList',
        {
          ApplicationID: this.$store.state.common.menuIDs[1],
          AcademicSessionID: this.AcademicSessionID,
          SchoolDistrictID: this.schooleVal.value
        }
      )
      this.xy.unloading()
      if (res.success) {
        let resData = res.data
        resData.map(item => {
          this.schooleColums.push({
            text: item.SchoolDistrictName,
            value: item.SchoolDistrictID
          })
        })
        // if (data === 'first') {
          this.schooleVal = this.schooleColums.length > 0 ? this.schooleColums[0] : ''
        // }
        // 获取教师
        this.getTeacher()
      } else {
        this.$toast.fail(res.data)
      }
    },
    //获取学年学期
    async getSessionNodeList() {
      this.xy.loading()
      let res = await this.xyapi.get(this.xyMApi + '/xy/comm/GetSessionNodeList')
      this.xy.unloading()
      if (res.success) {
        let resData = res.data
        resData.map(item => {
          let children = []
          item.children.map(item1 => {
            children.push({
              text: item1.label,
              value: item1.value
            })
          })
          this.yearColums.push({
            text: item.label,
            value: item.value,
            children: children
          })
        })
        // 默认选中当前学期
        let yearSession = [] //当前学期id
        let yearSessionName = [] //当前学期name
        let index = res.data
          .map(item => {
            return item.IsCurrent
          })
          .indexOf(true)
        if (index !== -1) {
          this.defaultIndex = index
          yearSession.push(res.data[index].value)
          yearSessionName.push(res.data[index].label)
          let index1 = res.data[index].children
            .map(item => {
              return item.IsCurrent
            })
            .indexOf(true)
          if (index1 !== -1) {
            yearSession.push(res.data[index].children[index1].value)
            yearSessionName.push(res.data[index].children[index1].label)
          }
        } else {
          if (res.data.length > 0) {
            yearSession.push(res.data[0].value)
            yearSessionName.push(res.data[0].label)
            if (res.data[0].children.length > 0) {
              this.yearVal
              yearSession.push(res.data[0].children[0].value)
              yearSessionName.push(res.data[0].children[0].label)
            } else {
              yearSession.push(0)
            }
          }
        }
        if (yearSession[1] !== undefined) {
          this.AcademicSessionID = yearSession[1]
          this.getSchoole()
        }
        this.yearVal.text = yearSessionName.join('')
        this.yearVal.value = yearSession.join(',')
      } else {
        this.$toast.fail(res.data)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  position: relative;
  background: #fff;
  height: 100vh;
  .header {
    height: 335px;
    background-image: url('../../../../assets/csmsTimeTable/class-1.png');
    background-size: 100%;
  }
  .c-body {
    position: relative;
    top: -80px;
    background: #fff;
    border-radius: 40px 40px 0px 0px;
    padding-top: 32px;
  }
  .title {
    font-size: 50px;
    font-weight: 600;
    color: #191b28;
    padding: 105px 0 0 88px;
  }
  .cell-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 112px;
    padding: 0 32px;
    .cell-left {
      color: #333333;
      font-size: 32px;
      width: 150px;
    }
    .cell-right {
      display: flex;
      align-items: center;
      justify-content: end;
      color: #333333;
      font-size: 32px;
      width: calc(100% - 150px);
      > p {
        margin-right: 16px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .query-btn {
    height: 88px;
    line-height: 88px;
    text-align: center;
    background: #618dfa;
    border-radius: 64px;
    color: #fff;
    margin: 100px auto;
    width: calc(100% - 66px);
  }
  /deep/ .van-picker__toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 32px;
    height: 96px;
  }
  /deep/ .van-picker__cancel {
    color: #5a6073;
    font-size: 32px;
  }
  /deep/ .van-picker__confirm {
    color: #2954ff;
    font-size: 32px;
  }
}
</style>
